import React from 'react'
import Linkify from 'react-linkify';
import TBCMedia from "./TBCMessage";
import AppBlobCache from '../AppBlobCache'

export default class extends React.Component
{
  render() {
    var message = this.props.message;
    // allowSkip: "false"
    // anim: "line"
    // autoDismiss: "false"
    // id: "14"
    // itemColor: "#666666"
    // position: "bottom"
    // style: "narrative"
    // type: "fullScreen"
    // urlColor: "#000000"
    // urlEnabled: "false"


    var media = this.props.media;

    // anim: "typewriter"
    // color: "#FFFFFF"
    // size: "xlarge"
    // style: "regular"

    if (!media || !media._attributes)
    {
      return <div id={"TBCMedia"}></div>;
    }

    var media_type = media._attributes.type;
    var media_src = media._attributes.src;
    var media_secondaryType = media._attributes.secondaryType;
    var media_secondarySrc = media._attributes.secondarySrc;

    var bclassName = this.props.bubble_color && `speech-bubble-${this.props.bubble_color.replace("#", '')}`;

    var default_text_style = {
      position: `relative`, display: `inline-block`,
    }
    if (this.props.is_header)
    {
      default_text_style = {};
    }
    if (media_type === 'sound')
    {
      bclassName = " ";
    }
    return (
        <div id={'TBCMedia'} className={`${bclassName} ${bclassName}-${this.props.bPosition}`} {...this.props} style={Object.assign({}, default_text_style, this.props.text_style, this.props.bubble_color ? {backgroundColor: this.props.bubble_color} : {})}>
          {
            media_type === 'image' && this.props.bubble_color ? (
                <div {...this.props} style={{position: 'relative', display: `inline-block`, left: 0, right: 0, bottom: 0, top: 0, width: 260, height: 260,
                  backgroundRepeat: `no-repeat`,
                  backgroundSize: `cover`,
                  backgroundPosition: `50% 50%`,
                  borderRadius: 8,
                  backgroundImage: `url(${new AppBlobCache().getMediaBlobByKey(`/media/image/${media_src}.jpg`)})`
                }}
                     onClick={(e) => {
                       this.props.onClick && this.props.onClick(e)
                     }}
                >
                  {this.props.children}
                </div>
            ) : null
          }
          {
            media_type === 'image' && !this.props.bubble_color ? (
                <img
                    onClick={(e) => {
                      this.props.onClick && this.props.onClick(e)
                    }}
                    src={new AppBlobCache().getMediaBlobByKey("/media/image/" + media_src + ".jpg")} style={{width: 260, height: `auto`}}/>
            ) : null
          }
          {
            media_type === 'sound' && this.props.bubble_color ? (
                <div {...this.props} style={{position: 'relative', display: `none`, left: 0, right: 0, bottom: 0, top: 0, width: 300, height: `auto`,
                  backgroundRepeat: `no-repeat`,
                  backgroundSize: `cover`,
                  backgroundPosition: `50% 50%`,
                  backgroundColor: '#666',
                  borderRadius: 8,
                }}>
                  <audio autoPlay controls>
                    <source src={new AppBlobCache().getMediaBlobByKey("/media/sound/"+ media_src +".mp3")} type="audio/mpeg"/>
                    Your browser does not support the audio element.
                  </audio>
                </div>
            ) : null
          }
          {
            media_type === 'sound' && !this.props.bubble_color ? (
                <div style={{display: `none`}}>
                  <audio autoPlay controls>
                    <source src={new AppBlobCache().getMediaBlobByKey("/media/sound/"+ media_src +".mp3")} type="audio/mpeg"/>
                    Your browser does not support the audio element.
                  </audio>
                </div>
            ) : null
          }




          {
            this.props.bubble_color ? (

                <style dangerouslySetInnerHTML={{__html: `
.${bclassName} {
	position: relative;
	background: ${this.props.bubble_color};
	border-radius: 14px;
	padding: 4px;
	margin-top: 20px;
}

.${bclassName}-right:after {
  content: '';
  position: absolute;
  top: 0;
  right: 10px;
  width: 0;
  height: 0;
  border: 9px solid transparent;
  border-bottom-color: ${this.props.bubble_color};
  border-top: 0;
  border-right: 0;
  margin-right: -4.5x;
  margin-top: -9px;
}

.${bclassName}-left:after {
	content: '';
	position: absolute;
	top: 0;
	left: 10px;
	width: 0;
	height: 0;
	border: 9px solid transparent;
	border-bottom-color: ${this.props.bubble_color};
	border-top: 0;
	border-left: 0;
	margin-left: -4.5x;
	margin-top: -9px;
}`}}>
                </style>
            ) : null
          }
        </div>
    );
  }

}